export const getFetchResponseData = async (response) => {
  const contentType = response.headers.get('content-type');
  const data = contentType && contentType.indexOf('application/json') !== -1
    ? await response.json()
    : await response.text();
  return response.status >= 400 ? Promise.reject(data) : data;
}